module.exports = __webpack_public_path__ + "img/icon-unlock-score.a3bdff0.svg";